// extracted by mini-css-extract-plugin
export default {"ButtonSize":"_8e37caec3d0809893602b6eeb3b06d82"};